import { Component, OnInit } from '@angular/core';
import { AppConfig } from './configs/app.config';
import { AuthService } from './services/auth.service';
import { DataService } from './services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppURL } from './app.url';
import { AlertService } from './services/alert.service';
import { LoadingService } from './services/loading.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent extends AppConfig implements OnInit {

  constructor(
    private _auth: AuthService,
    private data: DataService,
    private aActivatedRoutec: ActivatedRoute,
    private router: Router,
    private alert: AlertService,
    public loading: LoadingService
  ) {
    super();
    // console.log(this._auth.accessToken);

    // โหลดข้อมูลผู้ใช้งานมาตั้งแต่เริ่มระบบ
    if (this._auth.accessToken)
      this._auth.initalizeLoadUserLogin().subscribe();
  }


  ngOnInit() {
    this.aActivatedRoutec.queryParams.subscribe(res => {
      let page: string = res['page'];



      if (page) {
        if (page.split("payment-fail")[0] == "") if (!this.data.paymentItems) window.close();
        if (page.split("payment-success")[0] == "") {
          this.router.navigate(['/', AppURL.authen], { queryParams: { page: 'success' } })
        }
      }

    })
  }
}
